import { keyframes } from 'styled-components';

export const fromRight = keyframes`
	0% { transform: translate3d(100%, 0, 0); }
	100% { transform: translate3d(0, 0, 0); }
`;

export const moveUp = keyframes`
	0% { transform: translate3d(0, 0, 0); }
	100% { transform: translate3d(0, -100%, 0); }
`;

export const moveDown = keyframes`
	0% { transform: translate3d(0, 0, 0); }
	100% { transform: translate3d(0, 100%, 0); }
`;

export const moveFromUp = keyframes`
	0% { transform: translate3d(0, -100%, 0); }
	100% { transform: translate3d(0, 0, 0); }
`;

export const moveFromDown = keyframes`
	0% { transform: translate3d(0, 100%, 0); }
	100% { transform: translate3d(0, 0, 0); }
`;

export const fadeInAndUp = keyframes`
	0% {
		opacity: 0;
		transform: translate3d(0, 10px, 0);
	}
	100% {
		opacity: 1;
		transform: translate3d(0, 0, 0);
	}
`;

export const fadeInFromDown = keyframes`
	0% {
		opacity: 0;
		transform: translate3d(0, 100%, 0);
	}
	100% {
		opacity: 1;
		transform: translate3d(0, 0, 0);
	}
`;

export const fadeInFromUp = keyframes`
	0% {
		opacity: 0;
		transform: translate3d(0, -100%, 0);
	}
	100% {
		opacity: 1;
		transform: translate3d(0, 0, 0);
	}
`;

export const fadeDown = keyframes`
	0% {
		opacity: 1;
		transform: translate3d(0, 0, 0);
	}
	100% {
		opacity: 0;
		transform: translate3d(0, 100%, 0);
	}
`;

export const fadeUp = keyframes`
	0% {
		opacity: 1;
		transform: translate3d(0, 0, 0);
		height: 100%;
	}
	100% {
		opacity: 0;
		transform: translate3d(0, -100%, 0);
		height: 0;
	}
`;

export const bounce = keyframes`
	0% {
		transform: translateY(0px);
	}
	70% {
		transform: translateY(0px);
	}
	85% {
		transform: translateY(-2px);
	}
	95% {
		transform: translateY(1px);
	}
`;
